module.exports = __webpack_public_path__ + "assets/img/mark.afc987f5.svg";